<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <!-- <router-link to="/MusicDetails" class="audio-list" v-for="item in dataList" :key="item.id"> -->
      <div
        class="audio-list"
        v-for="item in dataList"
        :key="item.id"
        @click="changeMusic(item)"
      >
        <div class="hd">
          <i class="fa fa-music fa-2x"></i>
        </div>
        <div class="bd">
          <div class="title">{{ item.Title }}</div>
          <p class="date">{{ item.AddDateTime }}</p>
        </div>
        <div class="ft" v-if="item.IsStop">
          <van-icon name="checked" size="24" color="#555" />
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
      id: 0,
      uid: "",
      isSelf: false,
    };
  },
  computed: {
    ...mapGetters(["currentToken"]),
  },
  methods: {
    changeMusic(item) {
  
      var that = this;
      this.dataList.map((e) => {
        e.IsStop = false;
      });
      item.IsStop = true;
      console.log(item,"zzzzzzzzzzz");
      if (!item.IsPlay) {
        Toast("该音频无效，无法播放");
        this.$store.state.isPlaying2 = false;
        this.$emit("changemusic", item.MusicPlayPath);
      } else {
        this.$store.state.isPlaying2 = true;
        this.$emit("changemusic", item.MusicPlayPath);
        if (that.isSelf) {
          Dialog.confirm({
            title: "系统提示",
            message: '确定设置"' + item.Title + '"为纪念馆音乐吗？',
          }).then(
            () => {
              that.$store
                .dispatch({
                  type: "updateMusicInfoManageAddMusicRelationVue",
                  ColumnType: 2,
                  MemorialHallID: that.uid,
                  MusicId: item.MusicInfoID,
                })
                .then(
                  (res) => {
                    Toast(res.Message);
                  },
                  (err) => {}
                );
            },
            () => {}
          );
        }
      }
    },
    init() {
      var that = this;
      that.options = {
        type: "GetMusicInfoManageMusicInfoList",
        pageIndex: 1,
        IsSystem: true,
      };
      that.getList();
      that.getIsSelf();
    }, //
    getIsSelf() {
      var that = this;
      if (this.currentToken && this.currentToken.isLogin) {
        this.$store
          .dispatch({
            type: "getIsSelfMemorialHall",
            id: 0,
            Mid: that.uid,
          })
          .then(
            (res) => {
              that.isSelf = res == true;
            },
            (err) => {}
          );
      }
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1,
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1,
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.MusicInfoManageApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach((element) => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = dataList;
          }
        },
        (error) => {}
      );
    },
  },
  created() {
    var that = this;
    this.id = this.$store.state.mid;
    this.uid = this.$store.state.muid;
    that.init();
    this.dataList.map((e) => {
      e.IsStop = false;
    });
  },
};
</script>

<style>
.audio-list {
  margin: 15px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  padding: 10px;
}
.audio-list > .hd {
  position: relative;
  margin-right: 15px;
}
.audio-list > .hd > i {
  color: #666;
  font-size: 24px;
}
.audio-list > .bd {
  flex: 1;
  overflow: hidden;
}
.audio-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list > .bd > .date {
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list > .ft {
  margin-left: 10px;
}
</style>
